<div *ngIf="showContactPopup" class="contact-popup">
    <!-- Header -->
    <div class="contact-header" style="background-color: #79c7b8">
      <div class="header-content">
        <h3>Contact Details</h3>
        <button type="button" class="close-btn" (click)="closeContactPopup()">✕</button>
      </div>
    </div>
  
    <!-- Contact Info -->
    <div class="contact-details-container">
      <p><strong>Company Name:</strong> {{ contactData?.companyName || 'N/A' }}</p>
      <p><strong>Contact Person:</strong> {{ contactData?.contactPerson || 'N/A' }}</p>
      <p><strong>Email:</strong> 
        <a *ngIf="contactData?.email" [href]="'mailto:' + contactData.email">
          {{ contactData.email }}
        </a>
        <span *ngIf="!contactData?.email">N/A</span>
      </p>
      <p><strong>Phone:</strong> 
        <a *ngIf="contactData?.phone" [href]="'tel:' + contactData.phone">
          {{ contactData.phone }}
        </a>
        <span *ngIf="!contactData?.phone">N/A</span>
      </p>
      <p><strong>Fax:</strong> 
        <a *ngIf="contactData?.fax" [href]="'tel:' + contactData.fax">
          {{ contactData.fax }}
        </a>
        <span *ngIf="!contactData?.fax">N/A</span>
      </p>
      <p><strong>Address:</strong> {{ contactData?.address || 'N/A' }}</p>
    </div>
  </div>
